var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import ArrowNavDownIcon from "@bookingcom/bui-assets-react/streamline/ArrowNavDownIcon";
import InputCheckbox, {} from "../InputCheckbox/index.js";
import Actionable from "../Actionable/index.js";
import Icon from "../Icon/index.js";
import useId from "../../hooks/useId.js";
import TableCell from "./TableCell.js";
import styles from "@bookingcom/bui-core/css/Table.module.css";
var TableRow = function (props) {
    var selected = props.selected, collapsedContent = props.collapsedContent, onRowSelect = props.onRowSelect, checkboxValue = props.checkboxValue, headings = props.headings, className = props.className, checkboxName = props.checkboxName, cells = props.cells, viewLessLabel = props.viewLessLabel, viewMoreLabel = props.viewMoreLabel, verticalAlign = props.verticalAlign, hasCollapsibleRows = props.hasCollapsibleRows, onOpen = props.onOpen, onClose = props.onClose, defaultExpanded = props.defaultExpanded, expanded = props.expanded;
    var rowId = useId();
    var _a = React.useState(defaultExpanded || false), isExpanded = _a[0], setExpanded = _a[1];
    var isControlled = expanded !== undefined;
    var usedExpanded = isControlled ? expanded : isExpanded;
    var hasCheckbox = checkboxValue && checkboxName;
    var rowClassName = classNames(styles.row, verticalAlign && styles["row--vertical-align-".concat(verticalAlign)], !!collapsedContent && styles["row--collapse-togle"], usedExpanded && styles["row--expanded"], selected && styles["row--selected"], className);
    var handleRowExpand = function () {
        if (usedExpanded) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        else {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
        if (!isControlled)
            setExpanded(function (isExpanded) { return !isExpanded; });
    };
    var handleRowSelect = function (_a) {
        var checked = _a.checked, event = _a.event;
        if (onRowSelect && hasCheckbox && checkboxName) {
            onRowSelect({ value: checkboxValue, checked: checked, event: event, name: checkboxName });
        }
    };
    var getHeadingByIndex = function (cellIndex) {
        var adjustedCellStartIndex = 0;
        var adjustedHeadingEndIndex = -1;
        // Find what start index value would be if there were no colspans before this cell
        for (var i = 1; i <= cellIndex; i += 1) {
            var previousCell = cells[i - 1];
            var colspan = previousCell.colspan || 1;
            adjustedCellStartIndex += colspan;
        }
        // Find a heading which contains an  adjusted start index of the current cell
        for (var i = 0; i < headings.length; i++) {
            var heading = headings[i];
            var adjustedHeadingStartIndex = adjustedHeadingEndIndex + 1;
            var colspan = heading.colspan || 1;
            adjustedHeadingEndIndex += colspan;
            if (adjustedCellStartIndex >= adjustedHeadingStartIndex &&
                adjustedCellStartIndex <= adjustedHeadingEndIndex) {
                return heading;
            }
        }
        console.warn("BUI React: The following row has more cells than header: ", cells);
        return null;
    };
    var renderCheckbox = function () {
        if (!hasCheckbox || !checkboxName)
            return null;
        var cellClassName = classNames(styles.cell, styles["cell--action"]);
        return (React.createElement("td", { className: cellClassName },
            React.createElement(InputCheckbox, { name: checkboxName, value: checkboxValue, checked: selected || false, onChange: handleRowSelect })));
    };
    var renderToggle = function () {
        if (!hasCollapsibleRows)
            return null;
        var cellClassName = classNames(styles.cell, styles["cell--action"]);
        return (React.createElement("td", { className: cellClassName }, collapsedContent && (React.createElement(Actionable, { className: styles["expand-button"], onClick: handleRowExpand, attributes: {
                "aria-controls": rowId,
                "aria-label": usedExpanded ? viewLessLabel : viewMoreLabel,
            } },
            React.createElement(Icon, { svg: ArrowNavDownIcon, size: "medium" })))));
    };
    var renderCollapsedContent = function () {
        if (!collapsedContent)
            return null;
        var rowClassNames = classNames(styles.row, styles["row--collapsible"]);
        var colspan = cells.reduce(function (total, cell) { return total + (cell.colspan || 1); }, 0);
        if (hasCheckbox)
            colspan += 1;
        if (collapsedContent)
            colspan += 1;
        return (React.createElement("tr", { id: rowId, className: rowClassNames },
            React.createElement("td", { colSpan: hasCheckbox ? colspan + 1 : colspan, className: styles.cell }, collapsedContent)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: rowClassName },
            renderCheckbox(),
            renderToggle(),
            cells &&
                cells.map(function (cell, index) {
                    var heading = getHeadingByIndex(index);
                    return (React.createElement(TableCell, __assign({}, cell, { key: cell.key || cell.id || index, align: heading ? heading.align : undefined, onClick: index === 0 && collapsedContent ? handleRowExpand : undefined })));
                })),
        renderCollapsedContent()));
};
export default TableRow;
